document.addEventListener('DOMContentLoaded', function () {
  const scroller = document.getElementById('circles-scroller');
  const thumb = document.getElementById('scroll-thumb');
  if (!scroller || !thumb) return;

  function updateThumb() {
    const scrollableWidth = scroller.scrollWidth - scroller.clientWidth;

    if (scrollableWidth <= 0) {
      thumb.closest('.scroll-progress').style.visibility = 'hidden';
      return;
    }
    thumb.closest('.scroll-progress').style.visibility = 'visible';

    const trackWidth = thumb.parentElement.clientWidth;
    const thumbWidth = Math.max((scroller.clientWidth / scroller.scrollWidth) * trackWidth, 24);
    const scrollRatio = scroller.scrollLeft / scrollableWidth;
    const maxTranslate = trackWidth - thumbWidth;

    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translateX(' + (scrollRatio * maxTranslate) + 'px)';
  }

  scroller.addEventListener('scroll', updateThumb, { passive: true });
  window.addEventListener('resize', updateThumb);
  updateThumb();
});